import { Box, Grid } from "@mui/material";
import { EffectCoverflow } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { becomeDealerData } from "@/utils/staticData/aboutUsData";
import useResponsive from "@/hooks/useResponsive";

import JoinNetworkCard from "./JoinNetworkCard";
import "swiper/css/effect-coverflow";
import "./styles.css";

const JoinNetworkShowCase = () => {
  const isMobile = useResponsive("down", "md");
  const swiperData = [
    becomeDealerData[1],
    becomeDealerData[0],
    becomeDealerData[2],
  ];
  const coverflowEffectConfig = {
    rotate: 0,
    stretch: 0,
    depth: 200,
    modifier: 1,
    slideShadows: false,
  };

  return (
    <>
      {isMobile ? (
        <>
          {/* Slider */}
          <Box
            component={Swiper}
            spaceBetween={32}
            initialSlide={1}
            className="dealer-swiper"
            effect={"coverflow"}
            grabCursor={true}
            centeredSlides={true}
            slidesPerView={"auto"}
            coverflowEffect={coverflowEffectConfig}
            modules={[EffectCoverflow]}
            flexDirection="column"
            display="flex"
            boxSizing="border-box"
            bgcolor="background.default"
            sx={{ maxWidth: "100%", mb: { xs: 4, lg: 0 } }}
            py={{ xs: 4, md: 7, lg: 13 }}
            px={{ xs: 2, sm: 3 }}
          >
            {swiperData.map(({ title, subTitle, iconUrl, type }, index) => (
              <SwiperSlide key={index}>
                <JoinNetworkCard
                  title={title}
                  subtitle={subTitle}
                  iconUrl={iconUrl}
                  type={type}
                />
              </SwiperSlide>
            ))}
          </Box>
        </>
      ) : (
        <>
          {/* Grid */}
          <Box
            boxSizing="border-box"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            bgcolor="background.default"
            height={"100%"}
            py={{ xs: 4, md: 7, lg: 13, xl: 13.75 }}
            px={{ xs: 2, sm: 3 }}
            borderRadius={{ xs: 3.5, md: 5 }}
          >
            <Grid container spacing={{ xs: 1, md: 2, lg: 3 }}>
              {becomeDealerData.map(
                ({ title, subTitle, iconUrl, type }, index) => (
                  <Grid item xs={4} key={index}>
                    <JoinNetworkCard
                      title={title}
                      subtitle={subTitle}
                      iconUrl={iconUrl}
                      type={type}
                    />
                  </Grid>
                )
              )}
            </Grid>
          </Box>
        </>
      )}
    </>
  );
};

export default JoinNetworkShowCase;
